import React from 'react';

const ClosingChapterContent = () => {
  return (
    <article className="prose prose-lg max-w-none">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Closing Chapter</h1>
        <p className="text-xl text-gray-600">Who You Really Are</p>
        <p className="text-lg text-gray-500 mt-2">Identity Proclamation</p>
        <div className="flex justify-center gap-4 mt-4">
          <span className="text-2xl text-amber-600">✦</span>
          <span className="text-2xl text-amber-600">✦</span>
          <span className="text-2xl text-amber-600">✦</span>
        </div>
      </div>

      <div className="mb-12">
        <p className="text-gray-800 leading-relaxed mb-4 text-lg font-semibold">
          You are not a casualty waiting for evacuation. You are not a victim hoping to escape before the storm.
        </p>
        <p className="text-gray-800 leading-relaxed mb-4">
          You are the elect of God — chosen, sealed, kept. You are the honor guard of the returning King. You are the ones who will hear the Tekiah Gedolah Trump and rise to escort Him home. You are the overcomers the book of Revelation addresses in seven letters — and they were written to people expected to be present through trials, not absent from them.
        </p>
      </div>

      <div className="mb-12">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">You are a branch in the one olive tree.</h2>
        <p className="text-gray-800 leading-relaxed mb-4">
          Not a separate plant in a separate pot, following a separate program. You have been grafted into the same root that holds Abraham and Isaac and Jacob. You draw from the same sap. The covenant family is one family, and you are in it. The wall was torn down at Calvary, and it will not be rebuilt.
        </p>
      </div>

      <div className="bg-red-50 border-l-4 border-red-600 p-8 my-12">
        <h3 className="text-xl font-bold text-red-900 mb-4">One more word before you go.</h3>
        <p className="text-red-900 mb-4">
          Paul and Jesus both gave the same warning: Do not be deceived about the timing of His coming. That warning was not given carelessly. It was given because the enemy of your soul has a direct interest in your confusion on this point.
        </p>
        <p className="text-red-900 font-semibold">
          Hold the text. Read what it says. Trust what the grammar confirms.
        </p>
      </div>
    </article>
  );
};

export default ClosingChapterContent;
